<template>
  <div class="app-container">
    <div class="page-title">
      <h2>{{ $t('province.provinces') }}</h2>
    </div>
    <el-card v-if="checkRole(['Admin'])" class="box-card filter-card just-for-admin">
      <div slot="header" class="clearfix">
        <span>{{ $t('general.filter') }}</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="initSearch">{{ $t('general.init') }}</el-button>
      </div>
      <div class="filter-container">
        <el-radio v-model="activeList" label="actives" border @change="getSubProvincesList('indexactive')">{{ $t('general.F_actives') }}</el-radio>
        <el-radio v-model="activeList" label="desactives" border @change="getSubProvincesList('indexdesactive')">{{ $t('general.F_desactives') }}</el-radio>
        <el-radio v-model="activeList" label="disponibles" border @change="handleFilterProvinces">{{ $t('general.disponibles') }}</el-radio>
        <el-radio v-model="activeList" label="corbeille" class="danger-radio" border @change="getSubProvincesList('indexinvisible')">{{ $t('general.corbeille') }}</el-radio>
      </div>
    </el-card>

    <el-card class="box-card">
      <div class="filter-container">
        <el-input v-model="query.keyword" clearable :placeholder="$t('general.keyword')" class="wd-200 mr-15 filter-item" @keyup.enter.native="handleFilterProvinces" />
        <el-button v-waves class="mr-15 filter-item" type="primary" icon="el-icon-search" @click="handleFilterProvinces">
          {{ $t('general.search') }}
        </el-button>
        <el-button v-waves :loading="downloading" class="filter-item" type="primary" icon="el-icon-download" @click="handleDownload">
          {{ $t('general.export') }}
        </el-button>
        <el-button
          v-waves
          class="filter-item"
          type="primary"
          icon="el-icon-upload"
          @click="handleImportProvinces"
        >
          {{ $t('general.import') }}
        </el-button>
        <input
          ref="fileInput"
          type="file"
          style="display: none"
          accept=".xlsx, .xls"
          @change="onFileChange"
        >

        <el-button v-if="checkPermission(['create province'])" class="mr-15 filter-item" type="primary" icon="el-icon-plus" @click="handleCreateProvince">
          {{ $t('general.add') }}
        </el-button>
      </div>
      <el-table v-loading="loading" :data="list" border fit highlight-current-row style="width: 100%">

        <el-table-column align="center" :label="$t('province.reference')" width="300">
          <template slot-scope="scope">
            <span>{{ scope.row.ref }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="$t('province.name')">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="activeList!='corbeille' && checkPermission(['activate province'])" align="center" :label="$t('general.status')" width="150">
          <template slot-scope="scope">
            <el-switch
              style="display: block"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="true"
              :inactive-value="false"
              :value="scope.row.is_active"
              :disabled="!scope.row.is_visible"
              @change="setProvinceStatus(scope.row.id,'active')"
            />
          </template>
        </el-table-column>

        <el-table-column v-if="checkRole(['Admin']) && (activeList=='corbeille' || query.keyword)" align="center" :label="$t('general.restaurer')" width="100">
          <template slot-scope="scope">
            <el-switch
              v-if="!scope.row.is_visible"
              style="display: block"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="true"
              :inactive-value="false"
              :value="scope.row.is_visible"
              @change="setProvinceStatus(scope.row.id,'visible')"
            />
          </template>
        </el-table-column>
        <el-table-column v-if="checkPermission(['edit province','hide province','delete province'])" align="center" :label="1==1 ? $t('general.actions') : $t('general.suppressionDefinitive')" width="150">
          <template slot-scope="scope">
            <el-button v-if="scope.row.is_visible && checkPermission(['edit province'])" type="primary" size="small" icon="el-icon-view" style="margin-right:10px;" @click="handleEditProvince(scope.row.id);" />
            <el-button v-if="checkPermission(['hide province','delete province'])" slot="reference" type="danger" size="small" icon="el-icon-delete" style="margin-right:10px;" @click="handleDeleteProvince(scope.row.id, scope.row.is_visible, scope.row.name);" />
          </template>
        </el-table-column>
      </el-table>

      <pagination v-if="total > 0" :total="total" :page.sync="query.page" :limit.sync="query.limit" @pagination="getProvincesList" />

      <!-- ======= PROVINCE FORM ======= -->
      <el-dialog
        :title="editing ? $t('province.edit') + ' ' + currentProvince.name : $t('province.AddProvince')"
        :visible.sync="dialogCreateProvince"
        :before-close="handleCloseProvinceCreateDraw"
        :loading="provinceCreating"
        width="50%"
      >
        <div class="content-inputs">
          <el-form ref="provinceForm" :rules="rules" :model="currentProvince" label-position="left">
            <el-form-item :label="$t('province.name')" prop="name">
              <el-input v-model="currentProvince.name" />
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <div style="text-align:right;">
            <el-button plain type="danger" @click="dialogCreateProvince=false">
              {{ $t('permission.cancel') }}
            </el-button>
            <el-button type="primary" :loading="provinceCreating" @click="editing ? updateProvince() : createProvince()">
              {{ provinceCreating ? $t('general.saving') : $t('general.save') }}
            </el-button>
          </div>
        </span>
      </el-dialog>

      <!-- ======= END PROVINCE FORM ======= -->

    </el-card>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'; // Pagination
import Resource from '@/api/resource';
import waves from '@/directive/waves'; // Directives
import permission from '@/directive/permission'; //  directive Permission
import role from '@/directive/role'; // Directives Role
import checkPermission from '@/utils/permission'; // Vérification Permission
import checkRole from '@/utils/role'; // Vérification Roles
import moment from 'moment';
const provinceResource = new Resource('provinces');
export default {
  name: 'ProvincesList',
  components: { Pagination },
  directives: { waves, permission, role },
  data() {
    return {
      list: null,
      total: 0,
      loading: false,
      downloading: false,
      provinceCreating: false,
      editing: false,
      activeList: 'disponibles',
      query: {
        page: 1,
        limit: this.$limit,
        keyword: '',
      },
      currentProvince: {},
      dialogCreateProvince: false,
      currentProvinceId: 0,
      rules: {
        name: [{ required: true, message: this.$t('province.NameRequired'), trigger: 'blur' }],
      },
    };
  },
  computed: {
  },
  created() {
    this.resetNewProvince();
    this.getProvincesList();
  },
  methods: {
    checkPermission,
    checkRole,
    isEmptyArray(array){
      if (typeof array !== 'undefined' && array.length === 0) {
        return true;
      }
    },
    handleCloseProvinceCreateDraw(done) {
      this.$confirm(this.$t('general.closingWarningText'))
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    cancelProvinceForm() {
      this.$refs.ProvinceCreationDrawer.closeDrawer();
    },
    initSearch(){
      this.query = {
        page: 1,
        limit: this.$limit,
        keyword: '',
      };
      this.activeList = 'disponibles';
      this.handleFilterProvinces();
    },
    async getProvincesList() {
      this.loading = true;
      const { limit, page } = this.query;
      const { data, meta } = await provinceResource.list(this.query);
      this.list = data;
      this.list.forEach((element, index) => {
        element['index'] = (page - 1) * limit + index + 1;
      });
      this.total = meta.total;
      this.loading = false;
    },
    async getSubProvincesList(subUrl) {
      this.loading = true;
      const { data } = await provinceResource.sublist('/' + subUrl, this.query);
      this.list = data;
      this.loading = false;
    },
    handleFilterProvinces() {
      this.query.page = 1;
      this.getProvincesList();
    },
    handleCreateProvince() {
      this.editing = false;
      this.resetNewProvince();
      this.dialogCreateProvince = true;
      this.$nextTick(() => {
        this.$refs['provinceForm'].clearValidate();
      });
    },
    handleEditProvince(id){
      this.editing = true;
      this.resetNewProvince();
      this.currentProvince = this.list.find(abonne => abonne.id === id);
      this.dialogCreateProvince = true;
      this.$nextTick(() => {
        this.$refs['provinceForm'].clearValidate();
      });
    },
    async setProvinceStatus(id, type){
      const data = await provinceResource.get('toogle_' + type + '/' + id);
      if (data.success){
        this.$message({
          type: 'success',
          message: this.$t('general.statusUpdated'),
        });
        this.initSearch();
      } else {
        this.$message({
          type: 'danger',
          message: this.$t('general.statusUpdateError'),
        });
      }
    },
    handleDeleteProvince(id, visible, name) {
      this.$confirm(this.$t('province.deleteWarn') + ' ' + name + '. ' + this.$t('general.deleteContinue'), 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: this.$t('general.cancel'),
        type: 'warning',
      }).then(() => {
        if (!visible && (checkRole(['Admin']) || checkPermission(['delete province']))) {
          this.$swal({
            title: this.$t('general.SureQuestion'),
            text: this.$t('general.irrversibleMessage'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t('general.ouiSupprimer'),
          }).then((result) => {
            if (result.isConfirmed) {
              provinceResource.destroy(id).then(response => {
                this.$message({
                  type: 'success',
                  message: this.$t('province.suppressionEffectue'),
                });
                this.initSearch();
              }).catch(error => {
                console.log(error);
              });
            }
          });
        } else {
          this.setProvinceStatus(id, 'visible');
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('general.suppressionAnnule'),
        });
      });
    },
    createProvince() {
      this.$refs['provinceForm'].validate((valid) => {
        if (valid) {
          this.provinceCreating = true;
          provinceResource
            .store(this.currentProvince)
            .then(async(response) => {
              this.$message({
                message: this.$t('province.NewProvince') + ' ' + this.currentProvince.name + ' ' + this.$t('province.iscreatedSuccessfully'),
                type: 'success',
                duration: 5 * 1000,
              });
              this.currentProvinceId = response.data.id;
              this.resetNewProvince();
              this.dialogCreateProvince = false;
              this.handleFilterProvinces();
            })
            .catch(error => {
              console.log(error);
            })
            .finally(() => {
              this.provinceCreating = false;
            });
        } else {
          this.$message({
            type: 'danger',
            message: this.$t('general.invalidForm'),
          });
          return false;
        }
      });
    },
    updateProvince() {
      this.$refs['provinceForm'].validate((valid) => {
        if (valid) {
          this.provinceCreating = true;
          provinceResource.update(this.currentProvince.id, this.currentProvince).then(response => {
            this.resetNewProvince();
            this.handleFilterProvinces();
            this.$message({
              message: this.$t('province.isupdatedSuccessfully'),
              type: 'success',
              duration: 5 * 1000,
            });
            this.dialogCreateProvince = false;
            this.editing = false;
          })
            .catch(error => {
              console.log(error);
            })
            .finally(() => {
              this.provinceCreating = false;
            });
        } else {
          this.$message({
            type: 'danger',
            message: this.$t('general.invalidForm'),
          });
          return false;
        }
      });
    },
    resetNewProvince() {
      this.currentProvince = {
        name: '',
      };
    },
    handleDownload() {
      this.downloading = true;
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = ['ID', this.$t('province.reference'), this.$t('province.name')];
        const filterVal = ['id', 'ref', 'name'];
        const data = this.formatJson(filterVal, this.list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: 'Provinces list GEOSANTE_' + moment().format('DD-MM-YYYY_hh-mm'),
        });
        this.downloading = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },

    // Importation
    handleImportProvinces() {
    // Ouvre le sélecteur de fichier
      this.$refs.fileInput.click();
    },

    async onFileChange(event) {
      const file = event.target.files[0];
      if (!file) {
        return;
      }

      try {
      // Utilisez XLSX pour lire le fichier Excel
        const XLSX = await import('xlsx');
        const reader = new FileReader();

        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });

          // Supposons que les données sont dans la première feuille
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];

          // Convertir les données en JSON
          const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: ['code', 'name'], range: 1 });

          // Valider et envoyer les données au backend
          this.uploadProvinces(jsonData);
        };

        reader.readAsArrayBuffer(file);
      } catch (error) {
        console.error('Erreur lors de la lecture du fichier Excel:', error);
        this.$message.error(this.$t('general.importError'));
      }
    },

    async uploadProvinces(provinces) {
      try {
      // Envoyer les données au backend
        const response = await provinceResource.substore('/import', provinces);

        if (response.success) {
          this.$message.success(this.$t('province.importSuccess'));
          this.getProvincesList(); // Rafraîchir la liste des provinces
        } else {
          this.$message.error(this.$t('province.importError'));
        }
      } catch (error) {
        console.error('Erreur lors de l\'importation des provinces:', error);
        this.$message.error(this.$t('province.importError'));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.half-right {
    width: 70% !important;
    float: none !important;
    text-align: left !important;
    padding: 10px;
}
.edit-input {
  padding-right: 100px;
}
.cancel-btn {
  position: absolute;
  right: 15px;
  top: 10px;
}
.dialog-footer {
  text-align: left;
  padding-top: 0;
  margin-left: 150px;
}
.app-container {
  flex: 1;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  .block {
    float: left;
    min-width: 250px;
  }
  .clear-left {
    clear: left;
  }
}
</style>
